import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, testId, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="legal-page" data-testid={testId}>
      <div className="legal-wrap">
        <Link to="/" className="legal-back" data-testid="legal-back">
          <ArrowLeft size={14} /> Voltar ao início
        </Link>

        <h1 className="legal-title">{title}</h1>
        <p className="legal-updated">Última atualização: junho de 2026</p>

        {children}

        <p className="legal-footer-note">
          Akali AI é um produto operado por Fisiopilates Barra Mansa Ltda — CNPJ
          49.797.203/0001-40
        </p>
      </div>
    </section>
  );
}
